/* Savaya — Animations v5.1
 * Features:
 * 1. Scroll fade-in (sv-visible) — all content blocks
 * 2. Heading shimmer (sv-heading-active) — MagicUI AnimatedShinyText on h2/h3
 * 3. Mouse spotlight — CSS custom props --sv-mouse-x/--sv-mouse-y on benefit cards
 * 4. Stagger delay — children get sequential animation delays
 */
(function () {
  'use strict';

  /* ─── 1. Scroll reveal: sv-visible ────────────────────────────────── */
  function initScrollReveal() {
    var targets = document.querySelectorAll(
      '[class*="ai-image-text-container"],' +
      '[class*="ai-ingredient-row"]:not([class*="ai-ingredient-row__"]),' +
      '[class*="ai-faq-item"],' +
      '[class*="ai-rich-text-container"]'
    );

    if (!targets.length || !window.IntersectionObserver) {
      targets.forEach(function (el) { el.classList.add('sv-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sv-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ─── 2. Heading shimmer: sv-heading-active ────────────────────────── */
  function initHeadingShimmer() {
    /* Target all section headings inside our custom blocks */
    var headings = document.querySelectorAll(
      '[class*="ai-image-text-container"] h2,' +
      '[class*="ai-image-text-container"] h3,' +
      '[class*="ai-ingredient-section"] h2,' +
      '[class*="ai-ingredient-section"] h3,' +
      '[class*="ai-rich-text-container"] h2,' +
      '[class*="ai-rich-text-container"] h3,' +
      '[class*="ai-comparison"] h2,' +
      '[class*="ai-comparison"] h3,' +
      '[class*="ai-faq"] h2,' +
      '[class*="ai-faq"] h3,' +
      '[class*="ai-guarantee"] h2,' +
      '[class*="ai-guarantee"] h3,' +
      '[class*="ai-hero"] h2,' +
      '[class*="ai-hero"] h3'
    );

    if (!headings.length || !window.IntersectionObserver) return;

    /* Shimmer fires once: add class, then unobserve */
    var shimmerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          /* Small delay so the heading is already visible when shimmer starts */
          var el = entry.target;
          setTimeout(function () {
            el.classList.add('sv-heading-active');
          }, 180);
          shimmerObserver.unobserve(el);
        }
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -30px 0px' });

    headings.forEach(function (h) { shimmerObserver.observe(h); });
  }

  /* ─── 3. Mouse spotlight: --sv-mouse-x / --sv-mouse-y ─────────────── */
  function initMouseSpotlight() {
    var cards = document.querySelectorAll('[class*="ai-image-text-container"]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      /* Throttle with requestAnimationFrame to keep 60fps */
      var rafPending = false;
      var mouseX = -9999;
      var mouseY = -9999;

      card.addEventListener('mousemove', function (e) {
        if (rafPending) return;
        rafPending = true;

        var rect = card.getBoundingClientRect();
        mouseX = e.clientX - rect.left;
        mouseY = e.clientY - rect.top;

        requestAnimationFrame(function () {
          card.style.setProperty('--sv-mouse-x', mouseX + 'px');
          card.style.setProperty('--sv-mouse-y', mouseY + 'px');
          rafPending = false;
        });
      });

      /* Reset on leave — moves spotlight off-screen */
      card.addEventListener('mouseleave', function () {
        requestAnimationFrame(function () {
          card.style.setProperty('--sv-mouse-x', '-9999px');
          card.style.setProperty('--sv-mouse-y', '-9999px');
        });
      });
    });
  }

  /* ─── 4. Stagger delay for ingredient rows ─────────────────────────── */
  function initStaggerDelay() {
    /* Group ingredient rows by their parent section and stagger them */
    var sections = document.querySelectorAll('[class*="ai-ingredient-section"]');
    sections.forEach(function (section) {
      var rows = section.querySelectorAll(
        '[class*="ai-ingredient-row"]:not([class*="ai-ingredient-row__"])'
      );
      rows.forEach(function (row, i) {
        row.style.animationDelay = (i * 0.07) + 's';
      });
    });

    /* Stagger benefit cards within their grid */
    var grids = document.querySelectorAll('[class*="ai-benefits-grid"], [class*="ai-cards-grid"]');
    grids.forEach(function (grid) {
      var cards = grid.querySelectorAll('[class*="ai-image-text-container"]');
      cards.forEach(function (card, i) {
        card.style.animationDelay = (i * 0.10) + 's';
      });
    });
  }

  /* ─── Init all ──────────────────────────────────────────────────────── */
  function init() {
    initScrollReveal();
    initHeadingShimmer();
    initMouseSpotlight();
    initStaggerDelay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
